import { AppLanguage, SUPPORTED_LANGUAGES } from '@common/utils/lang';

import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  baseUrl: 'https://axenta.cloud/',
  apiUrl: 'https://axenta.cloud/api/',
  websocketUrl: 'wss://axenta.cloud/ws/',
  locales: SUPPORTED_LANGUAGES,
  defaultLocale: AppLanguage.English,
  systemType: 'monitoring',
  tokenKey: 'token',
  fullAccessTokenKey: 'full_access',
  flagsmithEnvironmentId: 'Nx4AwSMUD76pQnRHPmAhQ8',
  flagsmithApiUrl: 'https://features.axenta.cloud/api/v1/',
};
